/**
 * Copyright © Veeam Software Group GmbH.
 */

import { UserMfaPolicyAggregateStatusRepresentation } from '@veeam-vspc/models/web-controllers';

export const UserMfaStatuses = UserMfaPolicyAggregateStatusRepresentation;
export type UserMfaStatuses = UserMfaPolicyAggregateStatusRepresentation;
